import { createReducer, on } from '@ngrx/store';
import { setCurrentUserSetting } from './user-setting.actions';
import { UserSettingState } from './user-setting.state';

export const initialState: UserSettingState = {
  currentUserSetting: {
    user_id: null,
    mobile_is_public: false,
    email_is_public: false,
    phone_is_public: false,
    website_is_public: false,
    messaging_enabled: false,
    high_contrast: false,
    allow_weekly_digest: false,
    email_notifications_enabled: false,
    chat_email_notifications_enabled: false,
    chat_push_notifications_enabled: false,
    hidden_help_tips: [],
    push_notifications_enabled: false,
    own_posts_email_notifications_enabled: false,
    own_posts_push_notifications_enabled: false,
    own_location_email_notifications_enabled: false,
    own_location_push_notifications_enabled: false
  }
};

export const userSettingReducer = createReducer(
  initialState,
  on(setCurrentUserSetting, (state, userSetting) => ({
    ...state,
    currentUserSetting: userSetting
  }))
);
